// §6.4 — the house keymap, the "house" column of the table.
//
// Every chord here is `reserved`: the shell claims it, and an external app forwards it rather
// than acting on it (§9.7).
import type { Keymap } from '@hangar/shared';

export const houseKeymap: Keymap = {
  id: 'house',
  bindings: [
    { id: 'launcher.open', chord: 'Ctrl+Space', reserved: true },
    { id: 'switcher.windows', chord: 'Alt+Tab', reserved: true },
    { id: 'switcher.overview', chord: 'Alt+Shift+Tab', reserved: true },
    { id: 'window.snapLeft', chord: 'Meta+ArrowLeft', reserved: true },
    { id: 'window.snapRight', chord: 'Meta+ArrowRight', reserved: true },
    { id: 'window.snapUp', chord: 'Meta+ArrowUp', reserved: true },
    { id: 'window.snapDown', chord: 'Meta+ArrowDown', reserved: true },
    { id: 'desktop.previous', chord: 'Meta+Ctrl+ArrowLeft', reserved: true },
    { id: 'desktop.next', chord: 'Meta+Ctrl+ArrowRight', reserved: true },
    { id: 'clipboard.history', chord: 'Meta+Shift+V', reserved: true },
    { id: 'notifications.center', chord: 'Meta+Shift+N', reserved: true },
    { id: 'shell.immersive', chord: 'F11', reserved: true },
    { id: 'shell.lock', chord: 'Meta+L', reserved: true },
    { id: 'app.explorer', chord: 'Meta+E', reserved: true },
    { id: 'app.settings', chord: 'Meta+I', reserved: true },
    { id: 'window.close', chord: 'Ctrl+W', reserved: true },
    // §34.4 (D-505) — Quick Notes' capture card. `Ctrl+Alt+N` is free in every browser this runs
    // in, which is the property that matters: a capture chord the browser eats is not a capture
    // chord. Rebindable through `notes.captureChord` (§14).
    { id: 'notes.capture', chord: 'Ctrl+Alt+N', reserved: true },
  ],
};
